export * from './ActorRdfResolveHypermediaLinksNext';
